import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const DiseasePleiotropyIndex: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const dpiFormula = createMathML(`
    <mrow>
      <mi>DPI</mi>
      <mo>=</mo>
      <mo stretchy="false" form="prefix">(</mo>
      <mfrac>
        <msub>
          <mi>N</mi>
          <mi>dc</mi>
        </msub>
        <msub>
          <mi>N</mi>
          <mi>TC</mi>
        </msub>
      </mfrac>
      <mo stretchy="false" form="postfix">)</mo>
    </mrow>
  `);

  return (
    <MathMLRenderer 
      mathML={dpiFormula} 
      className={className} 
      style={style} 
    />
  );
};